// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"218":"771daa2e1903c6a1eb3b","231":"3fbe0c02a8f54cb42e57","597":"22668c582cc5bc262ecb","691":"c479f7edc32e8051c316","774":"c6e1ce137912fca64656"}[chunkId] + ".js";
};